import React from 'react'
import { CO2OptionsType } from '~/api/services/co2'
import FeedGroups from './FeedGroups'
interface Props {
  milkOptions: CO2OptionsType
}

const VariableCosts: React.FC<Props> = ({ milkOptions }) => {
  return <>
    <FeedGroups milkOptions={milkOptions} />
  </>
}
export default VariableCosts